exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-scroll-to-top {\n  position: fixed;\n  right: 4px;\n  background-color: black;\n  padding: 22px 22px 14px 22px;\n  border-radius: 10px 10px 0 0;\n  color: white;\n  font-size: 37px;\n  cursor: pointer;\n  opacity: 0.5;\n  transition: opacity 200ms ease-in, bottom 250ms ease-in;\n}\n.dyna-scroll-to-top--show {\n  bottom: 0;\n}\n.dyna-scroll-to-top--hide {\n  bottom: -84px;\n}\n.dyna-scroll-to-top:hover {\n  opacity: 0.8;\n}\n", ""]);

// exports
